import { apiCall } from "../service/api-service";

export const createPaymentApi = async (data) => {
  console.log("🚀 Creating payment with data:", data);
  const result = await apiCall("POST", "payment", data);
  console.log("📨 Create payment response:", result);
  return result;
};

export const updatePaymentApi = async (data, id) => {
  return apiCall("PUT", `payment/${id}`, data);
};

export const getPaymentDetailsApi = async (id) => {
  return apiCall("GET", `payment/edit/${id}`);
};
export const getPaymentViewDetailsApi = async (id, queryParams = "") => {
  console.log("🚀 Calling API: customer_payment_view/" + id + queryParams);
  const endpoint = `customer_payment_view/${id}${queryParams}`;
  const result = await apiCall("GET", endpoint);
  console.log("📨 API response:", result);
  return result;
};

// Get all payments (list)
export const getCustomerPaymentsListApi = async (params = {}) => {
  return apiCall("GET", `customer_payment${params}`);
};

export const getHistoryPaymentsListApi = async (params = {}) => {
  return apiCall("GET", `payment${params}`);
};

export const getPaymentHistoryViewApi = async (id) => {
  return apiCall("GET", `payment/view/${id}`);
};

export const getCustomerPaymentDetailsApi = async (customerId, params = {}) => {
  return apiCall("GET", `customer_invoices/${customerId}`, params);
};

export const getInvoicePaymentHistoryApi = async (invoiceId) => {
  return apiCall("GET", `invoice_payment_history/${invoiceId}`);
};

export const getPaymentTypesApi = async () => {
  console.log("🚀 Fetching payment types");
  const result = await apiCall("GET", "get_payment_type");
  console.log("📨 Payment types response:", result);
  return result;
};

// Normalizes payment type response to handle both string and object formats
export const normalizePaymentTypes = (raw) => {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((opt) => {
      if (typeof opt === "string") return { value: opt, label: opt };
      if (opt && typeof opt === "object") {
        const label = opt.label ?? opt.name ?? opt.type ?? opt.value ?? "";
        const value = opt.value ?? opt.id ?? opt.code ?? label;
        if (!label) return null;
        return { value: String(value), label: String(label) };
      }
      return null;
    })
    .filter(Boolean);
};
